export const emailToSpannerId = (email) => {
    if (!email) return "";
    let user = email.split("@")[0];
  
    if (user.endsWith("1")) user = user.slice(0, -1);
  
    return user.toUpperCase();
  };
  